<template>
  <div class="dataloggerManage">
    <div class="section">
      <div class="search">
        <div class="searchLeft">
          <!-- 添加用户 -->
          <button class="button-solid button buttonDeviceJurisdiction"
            @click="creatcount">{{ $t('account.createAccount') }}
            <span class="iconfont icon-add"></span>
          </button>
        </div>
        <div class="searchRight">
          <!-- 搜索 -->
          <div class="adminSearch">
            <el-input class="searchAll"  v-model.trim="search.email"
              @keyup.enter.native="getAccountList(true)" :placeholder="$t('browse.email')" clearable>
            </el-input>
          </div>
          <div class="adminSearch">
            <el-input class="searchAll"  v-model.trim="search.mobile"
              @keyup.enter.native="getAccountList(true)" :placeholder="$t('browse.mobile')" clearable>
            </el-input>
          </div>
          <div class="adminSearch">
            <el-input class="searchAll" ref="iptFocus" v-model.trim="search.usr"
              @keyup.enter.native="getAccountList(true)" :placeholder="this.$t('account.accountName2')" clearable>
            </el-input>
            <!-- 搜索 -->
            <span class="search-device" @click="getAccountList(true)">{{ $t('recharge.Search') }}</span>
            <!-- 取消 -->
            <!-- <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span> -->
          </div>
        </div>
      </div>
      <el-table :data="accountList"  stripe border height="100%" v-loading="loadingAccount"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" element-loading-spinner="el-icon-loading"
        class="tablemain tableloding" :empty-text="$t('account.nodata')"
        ref="multiplePnTable">
        <el-table-column
        :label="this.$t('settingalarm.list')"
          fixed
          type="index"
          width="70">
        </el-table-column>
        <el-table-column min-width="140px;" prop="uid"  :show-overflow-tooltip="true"
          label="uid">
        </el-table-column>
        <el-table-column min-width="140px;"  :show-overflow-tooltip="true"
          :label="this.$t('account.accountName')">
          <template slot-scope="scope">
            <span class="redirect" @click="enterAccount(scope.row)">{{scope.row.usr }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;" :show-overflow-tooltip="true"
          :label="this.$t('basic.Mobile1')">
          <template slot-scope="scope">
            <span>{{scope.row.mobile ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;" :show-overflow-tooltip="true"
          :label="this.$t('basic.Email1')">
          <template slot-scope="scope">
            <span>{{scope.row.email ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120px;" :show-overflow-tooltip="true"
          :label="this.$t('account.role')">
          <template slot-scope="scope">
            <span v-if="scope.row.role=='0'">{{$t('role.plantOwner') }}</span>
            <span v-if="scope.row.role=='1'">{{$t('role.manufacturer') }}</span>
            <span v-if="scope.row.role=='2'">{{$t('role.distributor') }}</span>
            <span v-if="scope.row.role=='5'">{{$t('role.viewer') }}</span>
            <span v-if="scope.row.role=='4'">{{$t('role.group') }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="120px;" :show-overflow-tooltip="true"
          :label="this.$t('account.accountStatus')">
          <template slot-scope="scope">
            <el-switch
              class="eb-switch"
              v-model="scope.row.enable"
              :active-value="true"
              :inactive-value="false"
              @change="editDeleteFlag(scope.row)"
            >{{ scope.row }}</el-switch>
          </template>
        </el-table-column>
        <el-table-column min-width="140px;" :show-overflow-tooltip="true"
          :label="this.$t('account.createTime')">
          <template slot-scope="scope">
            <span>{{scope.row.gts ||"--"}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="this.$t('device.Operation')" width="160px" class="fixedRgiht">
          <template slot-scope="scope">
            <el-button type="text" class="operation" :title="$t('device.edit')" @click="editcount(scope.row)">
              <i class="iconfont icon-bianji"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('device.delete')" @click="detelegroup(scope.row)">
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <div class="" style="margin-left:10px;">
        </div>
        <!-- 分页 -->
        <el-pagination class="pagination" background @size-change="getAccountList(true)"
          @current-change="() => getAccountList()" :current-page.sync="pagination.currentPage"
          :page-sizes="[10, 15, 20, 30, 50]" :page-size.sync="pagination.pagesize"
          layout="slot, sizes, total, pager, prev, next, jumper" :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <!-- 创建新账号 -->
    <!-- v-if="showCreatnewcountDialog" -->
    <account-dialog :title="$t('account.createAccount')" :visible.sync="showCreatnewcountDialog" width="550px"
      :class="{ 'showDialog': showCreatnewcountDialog, 'hideDialog': !showCreatnewcountDialog }" noFooter>
      <el-form ref="creatForm" :model="form" class="grid" slot="content" :rules="creatRules">
        <el-form-item :label="$t('account.accountName1')" prop="name">
          <el-input v-model.trim="form.name" clearable :placeholder="$t('account.accountName')" @keyup.enter.native="$refs.creatpwd.focus()">
            <!-- <img slot="prefix" src="@/assets/img/usr.png" style="width:18px;height:22px;" /> -->
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.password1')" prop="pwd">
          <el-input v-model.trim="form.pwd" :placeholder="$t('account.password')" clearable type="text" class="password"
            ref="creatpwd" @keyup.enter.native="$refs.creatconfPwd.focus()">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
          <el-input v-model.trim="form.confPwd" :placeholder="$t('account.confirmpassword')" clearable type="text"
            class="password" ref="creatconfPwd" @keyup.enter.native="$refs.creatmobile.focus()">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.mobile1')" prop="mobile">
          <el-input
            v-model.trim="form.mobile"
            :placeholder="$t('account.mobile')"
            clearable
            ref="creatmobile"
            @keyup.enter.native="$refs.createmail.focus()"
          >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.email1')" prop="email">
          <el-input
            v-model.trim="form.email"
            :placeholder="$t('account.email')"
            clearable
            type="text"
            ref="createmail"
            @keyup.enter.native="creatnewcount"
          >
          </el-input>
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <!-- <button class="button-hollow" @click="closeDialog">{{$t('account.cancel')}}</button> -->
          <button type="button" class="btn btn-dark" @click="creatnewcount">{{ $t('account.submit') }}</button>
        </div>
      </el-form>
    </account-dialog>
    <!-- 删除用户 去掉弹框的heard不加title=""和footer noFooter -->
    <account-dialog :title="$t('account.deleteUser')" :visible.sync="showDeletecountDialog" :width="'450px'"
      :class="{ 'showDialog': showDeletecountDialog, 'hideDialog': !showDeletecountDialog }" noFooter>
      <div class="content_tishi" slot="content" style="position:relative;">
            <div v-if="deleteLoading" class="delete-loading-mask">
      <i class="el-icon-loading"></i>
    </div>
        <div class="tital">
          <span class="contentdelete" style="width:100%;text-align:left;"><span style="color: rgba(255,204,102);">{{this.params.usr}}</span>{{ $t('account.confirmDelete') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;color:rgba(255, 255, 255, 0.7);">{{
            $t('account.notRecovered') }}</span>
        </div>
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" style="margin-right:10px;" @click="deleteoldcount">{{
            $t('account.confirm') }}</button>
                  <!-- <button type="button" class="btn btn-dark" style="margin-right:10px;"
        @click="deleteoldcount" :disabled="deleteLoading">
        <i v-if="deleteLoading" class="el-icon-loading"></i>
        {{ $t('account.confirm') }}
      </button> -->
          <button type="button" class="btn btn-light" @click="closeDialog">{{ $t('account.cancel') }}</button>
        </div>
      </div>
    </account-dialog>
    <!--编辑用户 -->
    <!-- v-if="showEditcountDialog" -->
    <account-dialog :title="$t('account.editUser')" :visible.sync="showEditcountDialog" :width="'550px'"
      :class="{ 'showDialog': showEditcountDialog, 'hideDialog': !showEditcountDialog }" noFooter>
      <el-form ref="editForm" :model="editForm" :rules="editRules" slot="content" class="grid"
        element-loading-spinner="el-icon-loading">
        <el-form-item :label="$t('account.accountName1')" prop="usr">
          <el-input v-model="editForm.usr" :placeholder="$t('account.accountName')" clearable>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.newPwd1')" prop="newPwd">
          <el-input v-model.trim="editForm.newPwd" :placeholder="$t('account.password')" type="text" class="password"
            clearable >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.confirmpassword1')" prop="confPwd">
          <el-input v-model.trim="editForm.confPwd" :placeholder="$t('account.confirmpassword')" type="text"
            class="password" clearable>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.mobile1')" prop="mobile">
          <el-input clearable type="text" v-model="editForm.mobile" :placeholder="$t('account.mobile')">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('account.email1')" prop="email">
          <el-input clearable v-model="editForm.email" :placeholder="$t('account.email')" auto-complete="off">
          </el-input>
        </el-form-item>
        <!-- Grid占位 -->
        <div></div>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="editoldcount">{{ $t('account.confirm') }}</button>
        </div>
      </el-form>
    </account-dialog>
  </div>
</template>
<script>
import accountDialog from "@/components/dialognew";
import encryption from "@/assets/js/encryption";
export default {
  components: {
    accountDialog,
  },
  data () {
    //新建账号的密码确认
    var validateconfPwd = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("message.pwdAgain")));
      } else if (value !== this.form.pwd) {
        callback(new Error(this.$t("message.pwdNotsame")));
      } else {
        callback();
      }
    };
    //编辑账号的密码确认
    var validateconfEditPwd = (rule, value, callback) => {
      if (this.editForm.newPwd&&!value) {
        callback(new Error(this.$t("message.pwdAgain")));
      }else if (value !== this.editForm.newPwd) {
        callback(new Error(this.$t("message.pwdNotsame")));
      } else {
        callback();
      }
    };
    return {
      deleteLoading: false,
      search: {
        usr:"",
        email:"",
        mobile:"",
      },
      loadingAccount: false,
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      accountList: [],
      // 搜索弹出
      showSearch: false,
      params: "",
      //创建账号弹窗
      showCreatnewcountDialog: false,
      // // 打开编辑用户信息弹框
      showEditcountDialog: false,
      // 打开删除账号弹框
      showDeletecountDialog: false,
      // 新增用户数据
      //创建新帐号
      form: {
        name: "",
        pwd: "",
        confPwd: "",
        mobile: "",
        email: "",
      },
      // //编辑账号里面的信息
      editForm: {
        mobile: "",
        usr: "",
        email: "",
        newPwd: "",
        confPwd: "",
        uid: "",
        enable: "",
      }, 
      creatRules: {
        name: [
          { required: true, message: this.$t("message.uname_is_required"), trigger: ["blur","change"] },
          {
            // pattern: /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/,
            // message: this.$t("signup.usrformat"),
            min: 2,
            max: 32,
            message: "用户名长度2-32位",
            trigger: ["blur","change"]
          }
        ],
        pwd: [
          { required: true, message: this.$t("message.pwd_is_required"), trigger: ["blur","change"] },
          {
            pattern: /^[\w]{6,32}$/,
            message: this.$t("signup.pwdformat"),
            trigger: ["blur","change"]
          }
        ],
        confPwd: [
          { required: true, validator: validateconfPwd, trigger: ["blur","change"] }
        ],
        email: [
        {
            max: 64,
            message: this.$t("message.email_info"),
            trigger: ["blur","change"]
          },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            // message: this.$t("account.title_info"),
            message: this.$t("message.email_info"),
            trigger: ["blur","change"]
          }
        ],
        mobile: [
          {
            // pattern: /^1[3456789]\d{9}$/,
            min: 6,
            max: 32,
            // message: this.$t("account.title_info1"),
            message: this.$t("signup.mobileformat"),
            trigger: ["blur","change"]
          }
        ],
      },
      editRules: {
        usr: [
          { required: true, message: this.$t("message.uname_is_required"), trigger: ["blur","change"] },
          {
            // pattern: /^([a-zA-Z0-9_\u4e00-\u9fa5]{2,32})$/,
            // message: this.$t("signup.usrformat"),
            min: 2,
            max: 32,
            message: "用户名长度2-32位",
            trigger: ["blur","change"]
          }
        ],
        newPwd: [
          {
            pattern: /^[\w]{6,32}$/,
            message: this.$t("signup.pwdformat"),
            trigger: ["blur","change"]
          }
        ],
        confPwd: [
          {validator: validateconfEditPwd, trigger: ["blur","change"] }
        ],
        email: [
        {
            max: 64,
            message: this.$t("message.email_info"),
            trigger: ["blur","change"]
          },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            // message: this.$t("account.title_info"),
            message: this.$t("message.email_info"),
            trigger: ["blur","change"]
          }
        ],
        mobile: [
          {
            // pattern: /^1[3456789]\d{9}$/,
            min: 6,
            max: 32,
            // message: this.$t("account.title_info1"),
            message: this.$t("signup.mobileformat"),
            trigger: ["blur","change"]
          }
        ],
      },
    };
  },
  computed: {
  },
  watch: {

  },
  created () {
    this.getAccountList()
  },
  methods: {
    // 启禁用
    editDeleteFlag(info){
      let params={
        enable:info.enable,
        uid:info.uid,
        usr:info.usr,
        i18n: this.$lang.currentLang,
      }
      this.$request.get("adminEditUsr",params).then(res=>{
        if (res.err==0) {
          if (info.enable) {
            this.$message.success(this.$t("account.enablesuccess"));
          }else{
            this.$message.success(this.$t("account.disablesuccess"));
          }
        }else{
          this.$message.error(this.$t(`errCode.${res.err}`));
        }
      })
    },
    // 用户列表数据
    getAccountList(reset){
      this.loadingAccount=true
      if (reset) this.pagination.currentPage = 1;
      let params={
        // usr:this.search.usr,
        // email:this.search.email,
        // mobile:this.search.mobile,
        ...this.search,
        page: this.pagination.currentPage-1,
        pagesize: this.pagination.pagesize,
        timezone:-(new Date().getTimezoneOffset() / 60),
        i18n: this.$lang.currentLang,
      }
      this.$request.get("adminQueryUsrAccount",params).then(res=>{
        this.loadingAccount=false
        if (res.err==0) {
          this.accountList=res.dat.items
          this.pagination.total=res.dat.totalCount
        }else{
          this.accountList = [];
          this.pagination.total = 0;
        }
      }).catch((err)=>{
        this.loadingAccount=false
        this.accountList = [];
        this.pagination.total = 0;
      })
    },
    // // 关闭搜索框
    // closeSearch () {
    //   this.showSearch = false;
    //   this.search.usr = '';
    //   this.getAccountList();
    // },
    // showSearchBtn () {
    //   this.showSearch = true;
    //   this.$nextTick(() => {
    //     this.$refs.iptFocus.focus();
    //   })
    // },
    //关闭对话框
    closeDialog () {
      this.showCreatnewcountDialog = false;
      this.showEditcountDialog = false;
      this.showdisablecountDialog = false;
      this.showGroupcountDialog = false;
      this.showResetpwdDialog = false;
      this.showDeletecountDialog = false;
    },
    //打开创建账号按钮
    creatcount () {
      this.$refs.creatForm.resetFields();
      this.showCreatnewcountDialog = true;
      Object.assign(this.$data.form,this.$options.data.call(this).form)
    },
    //创建账号
    creatnewcount () {
      this.$refs.creatForm.validate(valid => {
        if (!valid) return false;
        this.$request
          .get("adminAddUsr", {
            usr: this.form.name,
            email: this.form.email,
            mobile: this.form.mobile,
            pwd: encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.form.pwd),
                this.$store.state.user.secret
              )
            ),
            i18n: this.$lang.currentLang,
            role:"0",
            "company-key":"bnrl_frRFjEz8Mkn",
          })
          .then(res => {
            this.showCreatnewcountDialog = false;
            if (res.err == 0) {
              this.$message.success(this.$t("account.createSuc"));
              this.getAccountList()
            } else {
              this.$message.error( this.$t(`errCode.${res.err}`));
            }
          });
      });
    },
    //打开删除按钮
    detelegroup (info) {
      this.showDeletecountDialog = true;
      this.params = info;
    },
    //删除用户按钮
    deleteoldcount () {
      this.deleteLoading = true;
      this.$request.get("adminDelUsrInfo",{
        uid:this.params.uid,
        i18n: this.$lang.currentLang,
      }).then(res=>{
        this.deleteLoading = false;
        this.showDeletecountDialog = false;
        if (res.err==0) {
          this.$message.success(this.$t("account.deleteSuc"));
          this.getAccountList()
        }else{
          this.$message.error( this.$t(`errCode.${res.err}`));
        }
      }).catch(()=>{
        this.deleteLoading = false;
        this.showDeletecountDialog = false;
      });
    },
    // 打开编辑按钮
    editcount(info){
      Object.assign(this.$data.editForm,this.$options.data.call(this).editForm)
      this.showEditcountDialog = true;
      this.editForm.usr=info.usr
      this.editForm.email=info.email
      this.editForm.mobile=info.mobile
      this.editForm.uid=info.uid
      this.editForm.enable=info.enable
    },
    // 提交编辑校验
    editoldcount(){
      this.$refs.editForm.validate(valid => {
        if (!valid) return false;
        let params={
        uid:this.editForm.uid,
        email:this.editForm.email,
        mobile:this.editForm.mobile,
        usr:this.editForm.usr,
        pwd: this.editForm.newPwd?encryption.byte2hex(
              encryption.rc4(
                encryption.sha1(this.editForm.newPwd),
                this.$store.state.user.secret
              )
            ):'',
        enable:this.editForm.enable,
      }
        this.$request
          .get("adminEditUsr", params)
          .then(res => {
            if (res.err == 0) {
              this.showEditcountDialog = false;
              this.$message.success(this.$t("project.editSuc"));
              this.getAccountList()
            } else {
              this.$message.error( this.$t(`errCode.${res.err}`));
            }
          });
      });
    },
    // 跳转用户
    enterAccount (info) {
      this.$request
        .get("applyBrowsePermission", { uid: info.uid })
        .then(res => {
          if (res.err === 0) {
            let routeUrl = this.$router.resolve({
              path: "/home",
              query: {
                secret: res.dat.secret,
                token: res.dat.token,
                role: res.dat.role,
                pprAuth: res.dat.pprAuth,
              }
            });
            window.open(routeUrl.href, "_blank");
          } else {
            this.$message.error(this.$t(`errCode.${res.err}`));
          }
        });
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../../assets/css/mixin.less");

.dataloggerManage {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  // background-color: rgb(34, 45, 53);
  overflow: auto;
  .grid{
    grid-row-gap: 20px;
  }
  // 时间图标
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 12px;
    left: -165px;
    height: 24px;
    width: 24px;
    background: url(../../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  .redirect {
    color: @primaryTextColor;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .ico-recharge {
    background: url(../../../assets/img/general/Icon_Recharge.png);
  }

  .ico {
    display: inline-block;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    vertical-align: middle;
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      // align-self: flex-end;
      align-items: center;
      display: flex;
      justify-content: space-between;
      position: relative;
      .searchLeft{
        .buttonDeviceJurisdiction {
          padding: 0 17px 0 12px;
          background-color: @primaryTextColor;
          color: #222D35;
          border-radius: 0;
          span {
            padding-left: 5px;
          }
        }
      }
      .searchRight{
        display: flex;
        justify-content: flex-end;
        .adminSearch{
          border-left: 1px solid #7B8395 ;
          display: flex;
          justify-content: flex-start;
          .searchAll {
        /deep/.el-input__inner {
          width: 220px;
          padding-left: 10px;
        }
        }

        .search-device {
        display: inline-block;
        line-height: 48px;
        padding: 0 15px;
        width: 100%;
        font-size: 14px;
        background: #202D35;
        color: #33FFB6;
        cursor: pointer;

        &:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }
        }

        .search-hide {
        display: inline-block;
        // position: absolute;
        // right: -58px;
        // line-height: 48px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 15px;
        font-size: 14px;
        background: #202D35;
        color: #7B8395;
        border-left: 1px solid #7B8395;
        cursor: pointer;

        &:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }
        }
        }
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 110px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }

      .search-alert {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;
        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {

          // display: flex;
          // align-items: center;
          // justify-content: flex-end;
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px !important;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7B8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: 'X'
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);
      //开关按钮
      .eb-switch {

        // 默认(false)
        &.el-switch {

          // Input
          // .el-switch__input {}
          // 轨道
          /deep/.el-switch__core {
            position: relative;
            vertical-align: middle;
            margin: 0;
            display: inline-block;
            width: 40px;
            height: 20px;
            outline: 0;
            border-radius: 10px;
            box-sizing: border-box;
            background-color: #666;
            border: 1px solid #666;
            cursor: pointer;
            transition: border-color .3s, background-color .3s;

            // transition: unset;
            // 开关把手
            &:after {
              content: "";
              width: 12px;
              height: 12px;
              top: 3px;
              left: 3px;
              box-sizing: border-box;
              background-color: #fff;
              border: 1px solid #fff;
              border-radius: 100%;
            }
          }
        }

        // 激活(true)
        &.el-switch.is-checked {

          // 轨道
          /deep/.el-switch__core {
            background-color: @primaryTextColor;
            border: 1px solid @primaryTextColor;

            // 开关把手
            &:after {
              content: "";
              left: 100%;
              margin-left: -16px;
              background-color: rgba(255, 255, 255, 1);
              border: 1px solid rgba(255, 255, 255, 1);
            }
          }
        }
      }

      .operation i {
        color: @primaryTextColor;
      }

      // /deep/.el-table--border::after, 
      // /deep/.el-table--group::after {
      //   width: 0px;
      // }
      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
  .delete-loading-mask {
  position: absolute;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(34,45,53,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  font-size: 32px;
  color: #fff;
}
}
</style>
<style lang="less">
.tablemain.el-table--border::after {
  display: none;
}

</style>
